import { ReactNode } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { CashierAuthProvider } from './hooks/useCashierAuth';
import CashierProtectedRoute from './components/auth/CashierProtectedRoute';
import CashierLoginPage from './pages/CashierLoginPage';
import ForgotPasswordContactPage from './pages/ForgotPasswordContactPage';
import ForgotPasswordOtpPage from './pages/ForgotPasswordOtpPage';
import ForgotPasswordResetPage from './pages/ForgotPasswordResetPage';
import MyShiftsPage from './pages/MyShiftsPage';
import StartShiftPage from './pages/StartShiftPage';
import OpeningCashPage from './pages/OpeningCashPage';
import ActiveShiftPage from './pages/ActiveShiftPage';
import CashDropPage from './pages/CashDropPage';
import ClosingCountPage from './pages/ClosingCountPage';
import HandoverPage from './pages/HandoverPage';

function Protected({ children }: { children: ReactNode }) {
  return <CashierProtectedRoute>{children}</CashierProtectedRoute>;
}

export default function App() {
  return (
    <CashierAuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<CashierLoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordContactPage />} />
          <Route path="/forgot-password/otp" element={<ForgotPasswordOtpPage />} />
          <Route path="/forgot-password/reset" element={<ForgotPasswordResetPage />} />
          <Route
            path="/"
            element={(
              <Protected>
                <MyShiftsPage />
              </Protected>
            )}
          />
          <Route
            path="/shifts/:id/start"
            element={(
              <Protected>
                <StartShiftPage />
              </Protected>
            )}
          />
          <Route
            path="/shifts/:id/opening"
            element={(
              <Protected>
                <OpeningCashPage />
              </Protected>
            )}
          />
          <Route
            path="/shifts/:id/cash-drop"
            element={(
              <Protected>
                <CashDropPage />
              </Protected>
            )}
          />
          <Route
            path="/shifts/:id/closing"
            element={(
              <Protected>
                <ClosingCountPage />
              </Protected>
            )}
          />
          <Route
            path="/shifts/:id/handover"
            element={(
              <Protected>
                <HandoverPage />
              </Protected>
            )}
          />
          <Route
            path="/shifts/:id"
            element={(
              <Protected>
                <ActiveShiftPage />
              </Protected>
            )}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </CashierAuthProvider>
  );
}
